import { SETableColumnsProps } from "../../../../components/SETable";
import { RiDeleteBin6Line } from "react-icons/ri";
import React from "react";
import SETableIconButton from "../../../../components/SETable/SETableIconButton";
import { cnpjMask, formatDefaultValueSelect } from "../../../../../utils/mask";

interface TableColumnsProps {
  handleDelete?: (id?: number | string) => void;
}

export const tableColumns = ({
  handleDelete = () => {},
}: TableColumnsProps): SETableColumnsProps[] => [
  {
    id: "ano",
    label: "Ano",
    align: "left",
    minWidth: 10,
    customField: (ano) => <>{ano ?? ""}</>,
  },
  {
    id: "uf",
    label: "UF",
    minWidth: 10,
    align: "left",
  },
  {
    id: "cnpj",
    label: "CNPJ",
    align: "left",
    minWidth: 135,
    customField: cnpjMask,
  },
  {
    id: "protocoloSas",
    label: "Protocolo_SAS",
    align: "left",
    minWidth: 100,
  },
  {
    id: "nomeAtendente",
    label: "Nome Atendente",
    align: "left",
    minWidth: 150,
    customField: formatDefaultValueSelect,
  },
  {
    id: "status",
    label: "Status",
    align: "center",
    width: 200,
    customField: (value: any, row: any) => (
      <SETableIconButton onClick={() => handleDelete(row.id)}>
        <RiDeleteBin6Line size={20} color="#555770" />
      </SETableIconButton>
    ),
  },
];
